module.exports = __webpack_public_path__ + "img/nftinfoLink.c4472f7e.svg";